export {
  LocationApiClient,
  locationApiClient,
  createLocationApiClient,
} from './location-api';

export type { LocationsFilterParams } from './location-api';

export type {
  AssetLifecycleFunction,
  AssetLifecycleFunctionSchema,
  FacilityDtoSchema,
  FacilityDto,
  LocationTypeDtoSchema,
  LocationTypeDto,
  LocationBriefDtoSchema,
  LocationBriefDto,
  LocationResponseDtoSchema,
  LocationResponseDto,
  CreateLocationDto,
  UpdateLocationDto,
} from '@peritasai/types';
